import React from "react";
import { CheckOutlined } from "@ant-design/icons";

export const SuccessIcon = () => {
  return (
    <div
      style={{
        width: "18px",
        height: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "8px",
        backgroundColor: "#32eb71",
        borderRadius: "100px",
      }}
      className="dm-message-info-icon"
    >
      <CheckOutlined style={{ color: "white", fontSize: "10px" }} />
    </div>
  );
};
